import cn from 'classnames'
import type { HTMLAttributes } from 'react'
import styles from './full-page.module.css'

export const FullPageLayout = ({ children, className, style, ...restProps }: HTMLAttributes<HTMLDivElement>) => (
  <div className={cn(styles.container, className)} style={style} {...restProps}>
    {children}
  </div>
)
